import Events from 'tf-events-1';
import eventNames from './names';

const eventsBySeId = {}

const prepareEvents = instance => {
	
	if(eventsBySeId[instance.id]){
		return eventsBySeId[instance.id];
	}

	const events = eventsBySeId[instance.id] = Events();
	
	if(instance.cookies){
		instance.cookies.on(instance.cookies.events.PARTICIPANTS_AGES, () => {
			events.fire(eventNames.PARTICIPANTS_AGES);
		}, true);
	}
	
	instance.store.on(instance.store.events.ENGINE, () => {
		events.fire(eventNames.ENGINE);
	}, true);
	instance.store.on(instance.store.events.REQUEST, () => {
		events.fire(eventNames.REQUEST);
	}, true);
	instance.store.on(instance.store.events.FILTERS, () => {
		events.fire(eventNames.FILTERS);
	}, true);
	instance.store.on(instance.store.events.GEO_DATA, () => {
		events.fire(eventNames.GEO_DATA);
	}, true);
	instance.store.on(instance.store.events.RESULTS_PER_PAGE, () => {
		events.fire(eventNames.RESULTS_PER_PAGE);
	}, true);
	instance.store.on(instance.store.events.SORT, () => {
		events.fire(eventNames.SORT);
	}, true);
	instance.store.on(instance.store.events.PAGE, () => {
		events.fire(eventNames.PAGE);
	}, true);
	instance.store.on(instance.store.events.RESULT_CONTROLS, () => {
		events.fire(eventNames.RESULT_CONTROLS);
	}, true);

	instance.store.on(instance.store.events.PRODUCTS, () => {
		events.fire(eventNames.PRODUCTS);
	}, true);
	instance.store.on(instance.store.events.COUNTERS, () => {
		events.fire(eventNames.COUNTERS);
	}, true);
	instance.store.on(instance.store.events.MAP, () => {
		events.fire(eventNames.MAP);
	}, true);
	instance.store.on(instance.store.events.RESULTS, () => {
		events.fire(eventNames.RESULTS);
	}, true);

	instance.store.on(instance.store.events.ALL, () => {
		events.fire(eventNames.ALL);
	}, true);

	instance.server.on(instance.server.events.AFTER_REQUEST, () => {
		events.fire(eventNames.AFTER_REQUEST);
	}, true);
	instance.server.on(instance.server.events.BEFORE_REQUEST, () => {
		events.fire(eventNames.BEFORE_REQUEST);
	}, true);
	instance.server.on(instance.server.events.BEFORE_COUNTERS_REQUEST, () => {
		events.fire(eventNames.BEFORE_COUNTERS_REQUEST);
	}, true);
	instance.server.on(instance.server.events.AFTER_COUNTERS_REQUEST, () => {
		events.fire(eventNames.AFTER_COUNTERS_REQUEST);
	}, true);
	instance.server.on(instance.server.events.BEFORE_PRODUCTS_REQUEST, () => {
		events.fire(eventNames.BEFORE_PRODUCTS_REQUEST);
	}, true);
	instance.server.on(instance.server.events.AFTER_PRODUCTS_REQUEST, () => {
		events.fire(eventNames.AFTER_PRODUCTS_REQUEST);
	}, true);
	instance.server.on(instance.server.events.BEFORE_MAP_REQUEST, () => {
		events.fire(eventNames.BEFORE_MAP_REQUEST);
	}, true);
	instance.server.on(instance.server.events.AFTER_MAP_REQUEST, () => {
		events.fire(eventNames.AFTER_MAP_REQUEST);
	}, true);
	instance.server.on(instance.server.events.BEFORE_GEO_DATA_REQUEST, () => {
		events.fire(eventNames.BEFORE_GEO_DATA_REQUEST);
	}, true);
	instance.server.on(instance.server.events.AFTER_GEO_DATA_REQUEST, () => {
		events.fire(eventNames.AFTER_GEO_DATA_REQUEST);
	}, true);
	instance.server.on(instance.server.events.BEFORE_START_DATES_REQUEST, () => {
		events.fire(eventNames.BEFORE_START_DATES_REQUEST);
	}, true);
	instance.server.on(instance.server.events.AFTER_START_DATES_REQUEST, () => {
		events.fire(eventNames.AFTER_START_DATES_REQUEST);
	}, true);
	instance.server.on(instance.server.events.BEFORE_END_DATES_REQUEST, () => {
		events.fire(eventNames.BEFORE_END_DATES_REQUEST);
	}, true);
	instance.server.on(instance.server.events.AFTER_END_DATES_REQUEST, () => {
		events.fire(eventNames.AFTER_END_DATES_REQUEST);
	}, true);

	return events;
}

export default prepareEvents;